var render, staticRenderFns
import script from "./TextoRicoDoChat.vue?vue&type=script&lang=ts&"
export * from "./TextoRicoDoChat.vue?vue&type=script&lang=ts&"
import style0 from "./TextoRicoDoChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports